import React from 'react';
import styles from './Winners.module.scss';
import { WINNERS_DATA } from './WinnersData';
import 'react-multi-carousel/lib/styles.css';
import CustomCarousal from '../../common/CustomCarousal';

const WinnersSection = () => {
  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.contentContainer}`}>
        <div className={`${styles.heading}`}>Challenge Winners 🥳</div>
        <div className={`${styles.winnersContainer}`}>
          <div className={`${styles.winnersBgIllustration}`} />
          <CustomCarousal>
            {WINNERS_DATA?.map((winner, index) => {
              const winnerImg = winner.imgSrc.replace(
                'arre-public-assets.s3.ap-south-1.amazonaws.com',
                'asset.arredigital.co'
              );
              return (
                <div key={index} className={`${styles.winnerItem}`}>
                  <img className={`${styles.winnerImage}`} loading="lazy" src={winnerImg} alt={winner.username} />
                  <div className={`${styles.winnerTitle} px-2`}>{winner.name}</div>
                  <div className={`${styles.winnerTitle} px-2 -mt-1`}>@{winner.username}</div>
                </div>
              );
            })}
          </CustomCarousal>
        </div>
      </div>
    </div>
  );
};

export default WinnersSection;
